import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type PpCoinFace = 'pp' | 'corgi';

const COIN_SRC: Record<PpCoinFace, string> = {
  pp: '/images/perron-points/pp-coin.png',
  corgi: '/images/perron-points/pp-coin-corgi.png',
};

/**
 * Icono de moneda de Perrón Points. Puramente decorativo (`alt=""`,
 * `aria-hidden="true"`): el texto que lo acompaña ya transmite el significado.
 * Único punto de acceso a los PNG de `public/images/perron-points/` — no usar
 * `<img>` directo a las monedas fuera de este componente.
 */
@Component({
  selector: 'app-pp-coin',
  templateUrl: './pp-coin.component.html',
  styleUrl: './pp-coin.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PpCoinComponent {
  /** Anverso «PP» (uso por defecto, junto a cualquier cifra de Perrón Points) o reverso corgi (celebración). */
  face = input<PpCoinFace>('pp');
  /** Lado del icono en píxeles. */
  size = input<number>(18);

  protected readonly src = () => COIN_SRC[this.face()];
}
